<template>
<div>
  <div class="tab-item">
    <label class="mb-0 vform-label white">{{ $t('pivotPlacement') }} (global)
      <info-helper :text="$t('filter.pivotInfo')"/>
    </label>
    <div class="w-100"/>
    <select v-model="localPivotPlacement" class="custom-select form-text-dark mod-selector">
      <option v-for="(pos, index) in pivotPositions"
              :key="pos.key + index"
              :value="pos.key">{{ $t(pos.label) }}</option>
    </select>
    <info-helper class="ml-1 mb-0" text="pivotComment"/>
    <div class="w-100 mt-3"/>
    <label class="mb-0 vform-label white">{{ $t('pivotPlacement') }} (local)</label>
    <div class="form-group">
      <checkbox-widget
          :initial-value="localUsePivotValues"
          :label-text="$t('UseMetaSetValuesForPivots')"
          label-for="localPivotPlacement"
          class="mt-2"
          @change="(val) => { localUsePivotValues = val; }"
      />
    </div>
    <div class="w-100 mb-3"/>
    <label class="mr-1 mb-0 vform-label white">{{ $t('axisMultiplier') }}
      <info-helper text="axisMultiplierDesc"/>
    </label>
    <div class="d-flex">
      <div class="mr-1">
        <label class="lighter mb-0">x</label>
        <input v-model="localAxisMultiplier[0]" class="form-text form-text-dark" type="number">
      </div>
      <div>
        <label class="lighter mb-0">y</label>
        <input v-model="localAxisMultiplier[1]" class="form-text form-text-dark" type="number">
      </div>
      <div class="ml-1">
        <label class="lighter mb-0">z</label>
        <input v-model="localAxisMultiplier[2]" class="form-text form-text-dark" type="number">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoHelper from "@/components/InfoHelper.vue";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
export default {
  name: "CorrectionSection",
  components: {CheckboxWidget, InfoHelper},
  props: {
    filterId: {type: String, required: true},
    pivotPlacement: {type: String, required: true},
    usePivotValues: {type: Boolean, required: true},
    axisMultiplier: {type: Array, required: true},
  },
  data() {
    return {
      pivotPositions: [{
        key: 'source',
        label: this.$t('filter.sourceOriginal')
      },{
        key: 'center',
        label: this.$t('filter.center')
      },{
        key: 'bottom',
        label: this.$t('filter.bottom')
      },{
        key: 'top',
        label: this.$t('filter.top')
      },{
        key: 'left',
        label: this.$t('filter.left')
      },{
        key: 'right',
        label: this.$t('filter.right')
      },{
        key: 'front',
        label: this.$t('filter.front')
      },{
        key: 'back',
        label: this.$t('filter.back')
      }],
      //pivotPositions: ['source', 'center', 'bottom', 'top', 'left', 'right', 'front', 'back'],
      localPivotPlacement: this.pivotPlacement,
      localUsePivotValues: this.usePivotValues,
      localAxisMultiplier: this.axisMultiplier,
    }
  },
  watch: {
    axisMultiplier(newVal) {
      this.localAxisMultiplier = newVal;
    },
    usePivotValues(newVal) {
      this.localUsePivotValues = newVal;
    },
    pivotPlacement(newVal) {
      this.localPivotPlacement = newVal;
    },
    localPivotPlacement(newVal) {
      this.$emit('updatePivotPlacement', newVal);
    },
    localUsePivotValues(newVal) {
      this.$emit('updateUsePivotValues', newVal);
    },
    localAxisMultiplier: {
      handler(newVal) {
        this.$emit('updateAxisMultiplier', newVal);
      },
      deep: true
    }
  },
  beforeMount() {
    this.localPivotPlacement = this.pivotPlacement;
    this.localUsePivotValues = this.usePivotValues;
    this.localAxisMultiplier = this.axisMultiplier;
  }
}
</script>